'use strict';

angular.module('far.admin')
	.controller('AscentEditController', function ($log, $http, $window, Ascents, ascentEditForm, showModalMessage) {
		var vm = {
			progress: true,
            getDocumentUrl: getDocumentUrl,
			ascentModel: ascentEditForm(),
			getAscent: getAscent,
			submit: submit,
			selectedPeak: null,
			alerts: [],
			closeAlert: function(index) {
				vm.alerts.splice(index, 1);
			}
		};

        function getDocumentUrl(file_id) {
            return Routing.generate('api_upload_get_file', {fileStorage: file_id});
        }

		vm.ascentModel.$fields.ascent_date.label = 'Дата восхождения:';
		vm.ascentModel.$fields.ascent_type.label = 'Способ восхождения:';
		vm.ascentModel.$fields.first_ascent.label = 'Первопрохождение:';
		vm.ascentModel.$fields.first_climb.label = 'Первовосхождение:';
		vm.ascentModel.$fields.ascent_mountain_peak.label = 'Вершина:';
		vm.ascentModel.$fields.ascent_mountain_route.label = 'Маршрут:';
		vm.ascentModel.$fields.user_chief.label = 'Руководитель:';
		vm.ascentModel.$fields.user_participant.label = 'Участник:';
		vm.ascentModel.$fields.ascent_mountain_peak.uiSelectOptions.onSelect = function(item) {
			if (item && item.id != vm.selectedPeak) {
				vm.selectedPeak = item;
				refreshMountainRouteAutoComplete();
			}
		};
		vm.ascentModel.$fields.user_chief.uiSelectOptions.onSelect = function(item, model, options) {
			vm.ascent.updateUser(options.index, item);
		};
		vm.ascentModel.$fields.user_participant.uiSelectOptions.onSelect = function (item, model, options) {
			vm.ascent.updateUser(options.index, item);
		};
		vm.ascentModel.$fields.documentsFiles.uploader.removeFromQueue = function(value) {
			var index = this.getIndexOfItem(value);
			var item = this.queue[index];

			if (item.isUploading) {
				item.cancel();
			} else {
				vm.documents_files.splice(index, 1);
			}

			this.queue.splice(index, 1);
			item._destroy();

			this.progress = this._getTotalProgress();
		};

		function getAscent() {
			if (arguments.length) {
				vm.ascent = Ascents.get(arguments[0], vm.ascent_user_types, function (ascentData) {
					vm.ascent.ascent_date = new Date(vm.ascent.ascent_date);
					vm.selectedPeak = ascentData.ascent_mountain_route.mountain_peaks[0];
					refreshMountainRouteAutoComplete();

					vm.progress = false;
				});
			} else {
				vm.ascent = Ascents.new({}, vm.ascent_user_types);
				vm.progress = false;
			}
		}

		function refreshMountainRouteAutoComplete() {
			$http.get(Routing.generate('api_entities_get_mountainroutes', {
				offset: 0,
				limit: 100,
				peak_id: vm.selectedPeak.id
			})).then(function(response) {
				vm.ascentModel.$fields.ascent_mountain_route.items.length = 0;

				angular.forEach(response.data, function (route) {
					vm.ascentModel.$fields.ascent_mountain_route.items.push(route[0]);
				});
			}).catch(function(response) {
				$log.error(response);
			});
		}

		function submit() {
			vm.ascent.documents_files = vm.ascent.documents_files.concat(
				vm.documents_files
					.filter(function (document) {
						return document.isUploaded;
					})
					.map(function (document) {
						return document.serverData;
					})
			);
			vm.ascentModel.$fields.documentsFiles.uploader.clearQueue();

			vm.ascent.save()
				.then(function () {
					$window.location.href = Routing.generate('admin_ascents');
				})
				.catch(function (response) {
					$log.error(response);
					showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
				});
		}

		return vm;
	});
